import styled from 'styled-components';

export const StyledAdmissionNotes = styled.div`
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0px 2px 6px rgba(176, 186, 197, 0.600289);
  padding: 24px;
  
  h3{
    margin-bottom: 24px;
    font-size: 32px;
    line-height: 28px;
  }
  
  h5{
    text-align: center;
    margin-bottom: 32px;
  }
  
  
  p{
    margin-bottom: 0 !important;
    line-height: 24px;
  }
  
  .headerNote{
    display: flex;
    flex-direction: column;
    text-align: right;
  }
  
  .documentsName{
    font-weight: 600;
    margin-bottom: 8px !important;
  }
  
  .executor{
    &-caption{
      border-bottom: 1px solid rgba(196, 200, 203, 0.5);
    }
    
    &-subtitle{
      font-size: 12px;
    }
  }
  
  .modalSign {
    background: rgba(254, 239, 213, 0.5);
    padding: 16px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    .signTitle {
      font-size: 20px;
      line-height: 24px;
      font-family: Open Sans;
      font-style: normal;
      color: black;
    }
  }
  
  .ant{
    &-form{
      
      &-item {
        margin-bottom: 16px;
        line-height: 20px !important;
        
        &-label{
          label{
            font-size: 12px !important;
          }
        }
        
        &-required{
          font-weight: 700;

          &::before{
            margin-right: 0 !important;
            content: ' ' !important;
          }
          
          &::after{
            display: inline-block !important;
            color: #ff4d4f;
            font-size: 16px;
            font-family: Open Sans;
            line-height: 24px;
            content: '*';
          }
        }
      }
    }
    
     &-select-focused{
      .ant-select-selector{
        box-shadow: 0 0 0 2px rgba(81, 37, 143, 0.2) !important; 
        border-color: rgba(81, 37, 143, 1) !important;
      }
    }
  }
  
  
  `
